/**
 * Fuente única de verdad del scope contractual del proyecto.
 * Espejo de backend/scope.py — mantener sincronizado.
 */

export const SCOPE_MUNICIPALITIES = [
  {
    key: "cambados",
    name: "Cambados",
    population: 13787,
    area_km2: 23.5,
    center: [42.5137, -8.8117],
    color: "#0B4C7A",
    photoFolder: "cambados",
  },
  {
    key: "meis",
    name: "Meis",
    population: 4824,
    area_km2: 30.5,
    // iter45 · centro administrativo real (Casa do Concello, Mosteiro).
    // La coord anterior [42.4972, -8.7642] apuntaba a Barrantes (Ribadumia),
    // no a Meis. Verificado contra OSM/Nominatim (municipio "Meis, ES-PO").
    center: [42.5486, -8.7628],
    color: "#10B981",
    photoFolder: "meis",
  },
  {
    key: "vilanova-de-arousa",
    name: "Vilanova de Arousa",
    population: 10433,
    area_km2: 33.5,
    center: [42.5628, -8.8317],
    color: "#E76F51",
    photoFolder: "vilanova",
  },
];

export const SCOPE_TOTAL_POPULATION = SCOPE_MUNICIPALITIES.reduce(
  (n, c) => n + c.population,
  0
); // 29044

export const SCOPE_KEYS = SCOPE_MUNICIPALITIES.map((c) => c.key);
export const SCOPE_NAMES = SCOPE_MUNICIPALITIES.map((c) => c.name);

// Aliases con lowercase → canonical key
export const SCOPE_ALIASES = {
  cambados: "cambados",
  meis: "meis",
  "vilanova de arousa": "vilanova-de-arousa",
  vilanova: "vilanova-de-arousa",
  "vilanova-de-arousa": "vilanova-de-arousa",
  vilanova_de_arousa: "vilanova-de-arousa",
};

export function normalizeKey(value) {
  if (!value) return null;
  const k = String(value).trim().toLowerCase();
  return SCOPE_ALIASES[k] || null;
}

export function isInScope(value) {
  return normalizeKey(value) !== null;
}

export function getScopeByKey(key) {
  return SCOPE_MUNICIPALITIES.find((c) => c.key === key) || null;
}
